import React from "react";
import Learnings from "./Learnings";
import BringVision from "./assets/images/Home Page pixel.webp";
import Allplace from "./assets/images/Projects page.webp";
import Sophia from "./assets/images/shopia.webp";
import DanielLee from "./assets/images/lee.webp";
import PixelSolution from "./assets/images/pixel-solution.svg";
import HomeWireframe from "./assets/images/Home page wireframe pixel.webp";
import ProjectsWireframe from "./assets/images/Projects Page wireframe pixel.webp";
import TemplatesWireframe from "./assets/images/Templates page wireframe pixel.webp";
import WorkspaceWireframe from "./assets/images/Workspace wireframe pixel.webp";
import TemplatePrototype from "./assets/images/Template page pixel 1.webp";
import SpecificTemplatePrototype from "./assets/images/Instagram Story page pixel.webp";
import WorkspacePrototype from "./assets/images/Document Workspace pixel 1.webp";
import Testing from "./assets/images/Projects page pixel 1.webp";

const PixelBody = () => {
  return (
    <>
      <section className="wrapper productpagebody pixel-page">
        <section className="ecom-body">
          <div className="container">
            <h2 className="text-center fw-medium margin-set fs-56px mb-4">
              Bring ideas to life effortlessly
            </h2>
            <div className="row justify-content-center">
              <div className="col-md-6 my-3">
                <img src={BringVision} alt="Ecom Home" className="w-100" />
              </div>
              <div className="col-md-6 my-3 d-none d-md-block">
                <img src={Allplace} alt="Ecom HomePage" className="w-100" />
              </div>
              <p className="text-center text-md-end mt-16x">
                <a
                  href="https://www.figma.com/proto/kHlSYLpWu6gmjVmh1xgmWG/Pixel?page-id=3%3A2&node-id=190-280&viewport=914%2C-622%2C0.09&t=xlWNdOOKvM7AYTQh-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=190%3A280"
                  target="_blank"
                  className="proto-link"
                >
                  View Prototype
                </a>
              </p>
            </div>
          </div>
        </section>
        <section className="short-description mb-5">
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-md-6 my-2">
                <h2 className="fs-36px">Product Overview</h2>
              </div>
              <div className="col-md-6 my-2">
                <p className="fs-24 lh-custom">
                  A user-friendly design tool that offers editable templates and
                  seamless customization. It simplifies the creative process,
                  making editing effortless for all skill levels.
                </p>
              </div>
            </div>
            <div className="row mt-3 justify-content-center align-items-center">
              <div className="col-md-4 my-2">
                <div className="card card-bg-secondary h-100 pad-30x align-items-center justify-content-center w-305x ms-auto pixel-bg">
                  <h2 className="fs-24 mb-2 fw-normal mb-0">Timeline</h2>
                  <p className="fs-20 fw-normal mb-0">Jan 1 - Jan 15, 2025</p>
                </div>
              </div>
              <div className="col-md-4 my-2">
                <div className="card card-bg-secondary h-100 pad-30x rounded-10x align-items-center justify-content-center w-338x me-auto pixel-bg">
                  <h2 className="fs-24 mb-2 fw-normal mb-0">Role</h2>
                  <p className="fs-20 fw-normal mb-0">
                    UX Researcher, UX Designer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="brief-description my-5">
          <div className="container">
            <h2 className="fs-36px">Pain points</h2>
            <div className="row justify-content-between">
              <div className="col-md-5 mb-2">
                <div className="mini-title my-4">
                  <h2 className="fs-28x fm-soli text-center">User Insight</h2>
                </div>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3 pixel-bg">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Users struggle with a cluttered interface, making
                        navigation difficult.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3 pixel-bg">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Limited template flexibility restricts creativity.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3 pixel-bg">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Beginners find design tools overwhelming and complex.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 mb-2">
                <div className="mini-title my-4">
                  <h2 className="fs-28x fm-soli text-center">
                    Pain point Analysis
                  </h2>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end flex-wrap">
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3 pixel-bg">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        A cluttered UI leads to confusion and slows down the
                        design process.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3 pixel-bg">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Lack of customizable templates forces users to start
                        from scratch.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3 pixel-bg">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Complicated editing tools make it hard for new users to
                        learn and use the platform.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="persona my-5">
          <div className="container">
            <h1 className="fs-36px mb-4">Persona</h1>
            <div className="row mb-2">
              <div className="col-md-8 my-2">
                <div className="card persona-card p-3 h-100">
                  <h4 className="fs-24 fw-medium">Goals</h4>
                  <ul className="persona-list">
                    <li>Create eye-catching social media graphics quickly.</li>
                    <li>
                      Maintain brand consistency across different designs.
                    </li>
                    <li>Collaborate with team members for content creation.</li>
                  </ul>
                  <h4 className="fs-24 fw-medium">Challenges</h4>
                  <ul className="persona-list">
                    <li>
                      Needs a tool with ready-made templates and easy
                      customization.
                    </li>
                    <li>
                      Struggles with resizing designs for different platforms
                      efficiently.
                    </li>
                    <li>
                      Prefers a cloud-based solution for accessing designs from
                      multiple devices.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 my-2">
                <div className="card persona-card p-3 h-100 justify-content-center align-items-center">
                  <div className="emily-img mb-4">
                    <img src={Sophia} alt="Sophia" class="img-cover" />
                  </div>
                  <h4 className="fs-24">Sophia</h4>
                  <p className="fs-24 role">Social Media Manager</p>
                </div>
              </div>
            </div>
            <div className="row mb-2 flex-row-reverse">
              <div className="col-md-8 my-2">
                <div className="card persona-card p-3 h-100">
                  <h4 className="fs-24 fw-medium">Goals</h4>
                  <ul className="persona-list">
                    <li>
                      Design promotional materials without hiring a designer.
                    </li>
                    <li>Easily create logos, flyers, and marketing visuals.</li>
                    <li>
                      Access affordable design tools with premium-quality
                      results.
                    </li>
                  </ul>
                  <h4 className="fs-24 fw-medium">Challenges</h4>
                  <ul className="persona-list">
                    <li>
                      Lacks design skills and finds complex tools overwhelming.
                    </li>
                    <li>Needs an intuitive drag-and-drop interface.</li>
                    <li>
                      Wants a cost-effective solution with royalty-free assets.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 my-2">
                <div className="card persona-card p-3 h-100 justify-content-center align-items-center">
                  <div className="emily-img mb-4">
                    <img src={DanielLee} alt="Daniel Lee" class="img-cover" />
                  </div>
                  <h4 className="fs-24">Daniel Lee</h4>
                  <p className="fs-24 role">Small Business Owner</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="solution my-5">
          <div className="container">
            <div className="row">
              <h2 className="fs-36px solution-came">
                The Solution we came up with
              </h2>
              <div className="col-12">
                <div className="solution-svg img-contain mb-3">
                  <img src={PixelSolution} alt="Solutions" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container">
            <h2 className="fs-36px mb-4 my-5">Ideation</h2>
            <div className="row justify-content-center pixel-wireframe-main">
              <div className="col-md-5 p-w-m-item">
                <h2 className="text-center fs-28 fm-soli">Home</h2>
                <div className="wireframe-img">
                  <img src={HomeWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-5 p-w-m-item">
                <h2 className="text-center fs-28 fm-soli">Projects </h2>
                <div className="wireframe-img">
                  <img src={ProjectsWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-5 p-w-m-item">
                <h2 className="text-center fs-28 fm-soli">Templates</h2>
                <div className="wireframe-img">
                  <img src={TemplatesWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-5 p-w-m-item">
                <h2 className="text-center fs-28 fm-soli">Workspace</h2>
                <div className="wireframe-img">
                  <img src={WorkspaceWireframe} alt="Wire frame" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container">
            <h2 className="fs-36px proto-title">Prototype</h2>
            <div className="row mb-4 justify-content-center prototype-main">
              <div className="col-md-6 my-3">
                <div className="p-m-item1">
                  <h3 className="text-center fs-28 fm-soli">Template</h3>
                  <div className="prototype-img before">
                    <img src={TemplatePrototype} alt="Wire frame" />
                  </div>
                  <p className="fs-18 my-0 lh-24px">
                    A well-structured, visually engaging template gallery that
                    enhances user experience with clear categorization and
                    search functionality.
                  </p>
                </div>
              </div>
              <div className="col-md-6 my-3">
                <div className="p-m-item1">
                  <h3 className="text-center fs-28 fm-soli">
                    Specific Template
                  </h3>
                  <div className="prototype-img after">
                    <img src={SpecificTemplatePrototype} alt="Wire frame" />
                  </div>
                  <p className="fs-18 my-0 lh-24px">
                    Users can efficiently find and select templates that suit
                    their creative needs.
                  </p>
                </div>
              </div>
              <div className="col-md-6 my-3">
                <div className="p-m-item1">
                  <h3 className="text-center fs-28 fm-soli">Workspace</h3>
                  <div className="prototype-img after">
                    <img src={WorkspacePrototype} alt="Wire frame" />
                  </div>
                  <p className="fs-18 my-0 lh-24px">
                    A clean and intuitive interface with essential text
                    formatting tools, enabling users to customize designs
                    effortlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container my-3">
            <h2 className="fs-36px mb-4 my-5">Visual Design</h2>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="text-center my-4 fs-28 fm-soli">Color</h2>
              <div className="col-md-3 col-6 my-3">
                <div className="h-300 rounded-10x visual-design-card card-1 px-card-1">
                  <div className="content p-3">
                    <p className="mb-2 fs-24">Charcoal Black</p>
                    <p className="fs-20 fm-andi">#000000</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-6 my-3">
                <div className="h-300 rounded-10x visual-design-card card-2 px-card-2">
                  <div className="content p-3">
                    <p className="mb-2 fs-24">White</p>
                    <p className="fs-20 fm-andi">#FFFFFF</p>
                  </div>
                </div>
              </div>
              <div className="col-md-2 my-3">
                <div className="h-300 rounded-10x visual-design-card card-3 px-card-3">
                  <div className="content p-3">
                    <p className="mb-2 fs-24">Pastel Yellow</p>
                    <p className="fs-20 fm-andi">#FFE893</p>
                  </div>
                </div>
              </div>
              <div className="col-md-9 my-3">
                <p className="fs-24 lh-28x text-center">
                  Color in UI design enhances user experience, conveys brand
                  identity, creates visual hierarchy, improves accessibility,
                  evokes emotions, and ensures a cohesive and engaging
                  interface.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="typograpy">
          <div className="container">
            <div className="row justify-content-center">
              <h2 className="text-center mb-4 fs-28 fm-soli">Typography</h2>
              <div className="col-md-12">
                <div className="row mx-3 justify-content-center">
                  <div className="col-md-5 my-3">
                    <div className="font-card d-flex align-items-center justify-content-center">
                      <p className="mb-0 fs-32px lh-24x fm-sans fm-inter">
                        Inter
                      </p>
                    </div>
                  </div>
                  <div className="col-md-5 my-3">
                    <div className="font-card font-card-2 px-font-card-2 d-flex align-items-end">
                      <p className="mb-0 fs-32px lh-24x fm-sans">Aa</p>
                    </div>
                  </div>
                  <div className="col-md-9 mt-2">
                    <p className="fs-24 lh-28x text-center">
                      Typography in UI design enhances readability, establishes
                      brand personality, creates hierarchy, improves user
                      experience, ensures accessibility, and maintains visual
                      consistency across the interface.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container my-3 px-usable-testing-main">
            <h2 className="fs-36px mb-4 my-5">Usability Testing</h2>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="my-4 mb-1 fs-28 fm-soli">
                I want all my designs in one place so I can access them easily
                and continue working without searching for them!
              </h2>
              <div className="col-md-9 mt-3">
                <div className="price-drop-img mx-auto">
                  <img src={Testing} alt="Price Drop Image" />
                </div>
              </div>
              <div className="col-md-8 my-3">
                <p className="fs-24 lh-28x text-center">
                  Provides users a space to store, manage, and access their
                  recent designs. It also offers a visual overview of past
                  projects, enabling workflow continuity.
                </p>
              </div>
            </div>
          </div>
        </section>
        <Learnings />
      </section>
    </>
  );
};

export default PixelBody;
